<template>
  <b-sidebar :id="'sidebar-recordings-' + classroom.id" :title="classroom.name" sidebar-class="bb-offcanvas-panel full"
             width="100%" v-on:shown="initClassroomsRecordings" v-on:hidden="clearRecordings"
             bg-variant="white" right backdrop-variant="dark" backdrop no-header shadow>
    <template #default="{ hide }">
      <div class="bb-offcanvas-panel-wrap">
        <button class="bb-close" v-on:click="hide">
          <close-icon :size="25" :fill-color="iconColor"/>
        </button>
        <div class="panel-main-content">
          <header class="page-header page-header-collapsed">
            <div class="page-title-wrapper">
              <h1 class="page-title">Grabaciones: <bdi>{{classroom.name}}</bdi></h1>
            </div>
          </header>
          <div id="body-content" class="body-content instances-container">
            <div class="page-controls">
              <div class="page-controls__action-row">
                <button class="page-controls__primary-action button secondary short" id="page-add-course-button"
                        v-b-toggle.sidebar-no-header="'sidebar-new-recording-' + classroom.id">
                  <span>Añadir grabación</span>
                </button>
                <button class="page-controls__primary-action button secondary short" id="page-import-course-button"
                        v-b-toggle.sidebar-no-header="'sidebar-import-recording-' + classroom.id">
                  <span>Importar grabación</span>
                </button>
              </div>
            </div>
            <div v-if="!loading" class="full-width-content--small">
              <div v-if="!recordings.length" class="no-content no-results">
                <span class="no-content-title">No encontramos grabaciones que coincidan con esos criterios.</span>
              </div>
              <table v-if="recordings.length" class="content-table">
                <tbody>
                <tr class="content-table__header">
                  <th class="medium-4">Nombre de la sesión/nombres de la grabación</th>
                  <th class="medium-2">Fecha</th>
                  <th class="medium-1">Duración</th>
                  <th class="medium-1 recording-status-header content-table__th-tooltip">Estado
                  </th>
                  <th class="medium-1">Subtítulos</th>
                </tr>
                <tr v-for="recording in recordings" v-bind:key="recording.id" v-bind:class="{'element-list-row--inactive':(!recording.published || recording.expired), 'element-list-row':(recording.published && !recording.expired)}">
                  <td class="break-word content-table__emphasis buttonprevent">
                    <span class="inline-column-title ng-scope opacity-unpublished">Nombre de la sesión/nombre de la grabación:</span>
                    <b-dropdown menu-class="button-list-icons small-icons" variant="link button text show-launch-details" toggle-class="text-decoration-none" no-caret
                                @show="getLaunchLinkClick(recording)">
                      <template v-if="recording.targetSystem == 'COLLAB'" #button-content>
                        <bdi class="opacity-unpublished">{{ recording.sessionName }}/</bdi><bdi class="opacity-unpublished">{{ recording.mediaName }}</bdi>
                      </template>
                      <template v-else #button-content>
                        <bdi class="opacity-unpublished">{{ recording.name }}</bdi>
                      </template>
                      <b-dropdown-item-btn @click.native.capture.stop.prevent="getLaunchLinkClick(recording)" v-show="!recording.launchUrl" link-class="button">
                        <sync-icon class="svg-icon small default" :size="20" v-if="!recording.loadingLaunchUrl"/>
                        <loading-icon class="svg-icon small default rotate" :size="20" v-if="recording.loadingLaunchUrl"/>
                        <span>Obtener enlace</span>
                      </b-dropdown-item-btn>
                      <b-dropdown-item-btn  @click="launchUrl(recording.launchUrl, '_blank', recording)" v-show="recording.launchUrl" link-class="button">
                        <play-outline-icon class="svg-icon small default" :size="20"/>
                        <span>Reproducir ahora</span>
                      </b-dropdown-item-btn>
                    </b-dropdown>
                    <LanguageCaptionSelectSidebar
                      :classroom="classroom"
                      :recording="recording">
                    </LanguageCaptionSelectSidebar>
                    <EventsReportAdminSidebar
                      :recording="recording"
                      returnIconColor="#262626">
                    </EventsReportAdminSidebar>
                  </td>
                  <td class="date">
                    <span class="inline-column-title ng-scope">Fecha:</span>
                    <span>{{ recording.endTime | moment("D/M/YY HH:mm") }}</span>
                  </td>
                  <td class="duration-column">
                    <span class="inline-column-title ng-scope">Duración:</span>
                    <span>{{ msToTime(recording.duration) }}</span>
                  </td>
                  <td class="status-column" >
                    <span class="inline-column-title ng-scope">Estado:</span>
                    <span v-if="recording.deleted" class="status-column__text">
                      <close-circle-outline-icon fill-color="#c23e37" :size="20"/>
                      <span>Eliminada</span>
                    </span>
                    <span v-else-if="recording.expired" class="status-column__text">
                      <alert-circle-outline-icon fill-color="#d9b82b" :size="20"/>
                      <span>Archivada</span>
                    </span>
                    <span v-else class="status-column__text">
                      <check-circle-outline-icon fill-color="#007d2c" :size="20"/>
                      <span>Listo</span>
                    </span>
                  </td>
                  <td class="status-column">
                    <span class="inline-column-title ng-scope">Subtítulos:</span>
                    <span v-if="recording.targetSystem === 'COLLABSECONDARY' && recording.withCaptions === 1" class="status-column__text">
                      <closed-caption-outline-icon fill-color="#999999" :size="20"/>
                      <span>Generando</span>
                    </span>
                    <span v-else-if="recording.targetSystem === 'COLLABSECONDARY' && recording.withCaptions === 2" class="status-column__text">
                      <closed-caption-outline-icon fill-color="#262626" :size="20"/>
                      <span>Listo</span>
                    </span>
                    <span v-else-if="recording.targetSystem === 'COLLABSECONDARY' && recording.withCaptions === 3" class="status-column__text">
                      <closed-caption-outline-icon fill-color="#c23e37" :size="20"/>
                      <span>Fallido</span>
                    </span>
                    <span v-else-if="recording.targetSystem === 'COLLABSECONDARY'" class="status-column__text">
                      <closed-caption-outline-icon fill-color="#999999" :size="20"/>
                      <span>Sin generar</span>
                    </span>
                    <span v-else class="status-column__text">
                      <span>No disponible</span>
                    </span>
                  </td>
                  <td class="item-controls" style="padding-right: 16px;">
                    <b-dropdown v-if="!recording.expired" right menu-class="button-list-icons small-icons" variant=" icon-button session-row-options list-item-icon has-tooltip" toggle-class="text-decoration-none" no-caret
                                @show="getLaunchLinkClick(recording)">
                      <template :id="'recording-options-' + recording.id" #button-content>
                        <dots-horizontal-circle-outline-icon class="recording-admin-icon" :size="20"/>
                        <b-tooltip :target="'recording-options-' + recording.id" triggers="hover">
                          Opciones de grabación
                        </b-tooltip>
                      </template>
                      <b-dropdown-item-btn @click.native.capture.stop.prevent="getLaunchLinkClick(recording)" v-show="!recording.launchUrl" link-class="button">
                        <sync-icon class="svg-icon small default" :size="20" v-if="!recording.loadingLaunchUrl"/>
                        <loading-icon class="svg-icon small default rotate" :size="20" v-if="recording.loadingLaunchUrl"/>
                        <span>Obtener enlace</span>
                      </b-dropdown-item-btn>
                      <b-dropdown-item-btn @click="launchUrl(recording.launchUrl, '_blank', recording)" v-show="recording.launchUrl" link-class="button">
                        <play-outline-icon class="svg-icon small default" :size="20"/>
                        <span>Reproducir ahora</span>
                      </b-dropdown-item-btn>
                      <b-dropdown-item-btn v-if="recording.canDownload" @click="getDownloadLinkClick(recording)" link-class="button" href="#">
                        <cloud-download-outline-icon class="svg-icon small default" :size="20"/>
                        <span>Descargar</span>
                      </b-dropdown-item-btn>
                      <b-dropdown-item-btn link-class="button" v-if="recording.targetSystem === 'COLLABSECONDARY'" v-b-toggle.sidebar-no-header="'sidebar-language-captions-' + recording.id">
                        <closed-caption-outline-icon class="svg-icon small default" :size="20"/>
                        <span>Generar subtítulos</span>
                      </b-dropdown-item-btn>
                      <b-dropdown-item-btn v-if="recording.targetSystem === 'COLLABSECONDARY'" @click="confirmTogglePublish(recording)" link-class="button" href="#">
                        <eye-outline-icon v-if="!recording.published" class="svg-icon small default" :size="20"/>
                        <eye-off-outline-icon v-if="recording.published" class="svg-icon small default" :size="20"/>
                        <span v-if="recording.published">Ocultar grabación</span>
                        <span v-else>Publicar grabación</span>
                      </b-dropdown-item-btn>
                      <b-dropdown-item-btn v-if="recording.targetSystem === 'COLLABSECONDARY'" @click="dispatchShowReportEvent(recording.id)"  link-class="button" v-b-toggle.sidebar-no-header="'sidebar-event-report-' + recording.id">
                        <text-box-search-outline-icon class="svg-icon small default" :size="20"/>
                        <span>Ver informes</span>
                      </b-dropdown-item-btn>
                    </b-dropdown>
                  </td>
                </tr>
                </tbody>
              </table>
              <RecordingVideoPlayer :player_url="player_url" :captions_url="player_captions_url" :chat="chat" :title="player_title" :player_id="classroom.id" :captions_language="captions_language" :recording="current_recording"></RecordingVideoPlayer>
            </div>
          </div>
        </div>
      </div>
      <EditRecordingSidebar
        :classroom="classroom">
      </EditRecordingSidebar>
      <ImportRecordingSesionsSidebar
        :classroomOrigin="classroom">
      </ImportRecordingSesionsSidebar>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import CheckCircleOutlineIcon from 'vue-material-design-icons/CheckCircleOutline.vue'
import SyncIcon from 'vue-material-design-icons/Sync.vue'
import CloudDownloadOutlineIcon from 'vue-material-design-icons/CloudDownloadOutline.vue'
import ClosedCaptionOutlineIcon from 'vue-material-design-icons/ClosedCaptionOutline.vue'
import PlayOutlineIcon from 'vue-material-design-icons/PlayOutline.vue'
import LoadingIcon from 'vue-material-design-icons/Loading.vue'
import DotsHorizontalCircleOutlineIcon from 'vue-material-design-icons/DotsHorizontalCircleOutline.vue'
import EyeOffOutlineIcon from 'vue-material-design-icons/EyeOffOutline.vue'
import EyeOutlineIcon from 'vue-material-design-icons/EyeOutline.vue'
import TextBoxSearchOutlineIcon from 'vue-material-design-icons/TextBoxSearchOutline.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import RecordingVideoPlayer from '../../Player/RecordingVideoPlayer'
import EditRecordingSidebar from './EditRecordingSidebar'
import ImportRecordingSesionsSidebar from './ImportRecordingSesionsSidebar'
import LanguageCaptionSelectSidebar from './LanguageCaptionSelectSidebar'
import EventsReportAdminSidebar from './EventsReportAdminSidebar'

export default {
  name: 'SessionRecordingsSidebar',
  components: {
    RecordingVideoPlayer, CloseIcon, KeyboardReturnIcon, PlayOutlineIcon, CheckCircleOutlineIcon, SyncIcon, LoadingIcon, CloudDownloadOutlineIcon, DotsHorizontalCircleOutlineIcon, ClosedCaptionOutlineIcon, EyeOffOutlineIcon, EyeOutlineIcon, TextBoxSearchOutlineIcon, EditRecordingSidebar, LanguageCaptionSelectSidebar, ImportRecordingSesionsSidebar, EventsReportAdminSidebar},
  mixins: [utilitiesMixin],
  props: ['classroom', 'iconColor'],
  data () {
    return {
      loading: false,
      player_url: null,
      player_id: null,
      player_title: null,
      player_captions_url: null,
      chat: null,
      recordings: [],
      captions_language: null,
      current_recording: null
    }
  },
  methods: {
    initClassroomsRecordings () {
      let vueComponent = this
      this.loading = true

      let filterParams = new URLSearchParams()
      filterParams.append('classroomId', this.classroom.id)

      // CMM: Se recuperan las grabaciones asociadas a la clase
      window.axios.get('recordings/', {params: filterParams}).then((response) => {
        // CMM: Se efectúan las matrículas en los grupos y se recuperan las URLs de acceso
        vueComponent.recordings = response.data
        this.loading = false
      })
    },
    clearRecordings () {
      this.recordings = []
    },
    getLaunchLinkClick (recording) {
      let vueComponent = this
      let validMinutes = 5
      if (!recording.loadingLaunchUrl && !recording.launchUrl) {
        this.$set(recording, 'loadingLaunchUrl', true)
        // CMM: Se recupera la URL de la grabación
        let urlParams = {
          targetSystem: recording.targetSystem,
          acInstanceId: recording.acInstance,
          validMinutes: validMinutes
        }
        window.axios.get('recordings/' + recording.id + '/url/', {params: urlParams}).then((response) => {
          vueComponent.$set(recording, 'loadingLaunchUrl', false)
          vueComponent.$set(recording, 'launchUrl', response.data.url)
          // CMM: A los 5 minutos el link pierde vigencia
          setTimeout(function () {
            vueComponent.$set(recording, 'launchUrl', '')
          }, validMinutes * 60000)
        })
      }
    },
    launchUrl (url, target, recording) {
      // CMM: Si es una grabación de Collaborate se abre el player en modal
      if (recording && recording.targetSystem === 'COLLABSECONDARY') {
        this.player_url = url
        this.player_title = recording.name
        this.player_captions_url = recording.captionsUrl
        this.chat = recording.chat
        this.captions_language = recording.captionsLanguage
        this.current_recording = recording
        this.$bvModal.show('collaborate-recording-player-' + this.classroom.id)
      } else {
        window.open(url, target)
      }
    },
    getDownloadLinkClick (recording) {
      let vueComponent = this
      let urlParams = {
        targetSystem: recording.targetSystem,
        acInstanceId: recording.acInstance,
        disposition: 'download'
      }
      window.axios.get('recordings/' + recording.id + '/url/', {params: urlParams}).then((response) => {
        vueComponent.launchUrl(response.data.url, '_self')
      })
    },
    confirmTogglePublish (recording) {
      let vueComponent = this
      let message = `Se va a proceder a ocultar la grabación y dejará de ser visible en las aulas. ¿Quieres continuar?`
      if (!recording.published) {
        message = `Se va a proceder a publicar la grabación y será visible en las aulas. ¿Quieres continuar?`
      }
      this.$confirm(
        {
          title: `Cambio de estado de grabación`,
          message: message,
          button: {
            no: 'No, cancelar',
            yes: 'Sí, continuar'
          },
          callback: confirm => {
            if (confirm) {
              vueComponent.togglePublish(recording)
            }
          }
        }
      )
    },
    togglePublish (recording) {
      let vueComponent = this

      this.$set(recording, 'published', !recording.published)
      let recordingParam = {...recording}
      vueComponent.filterProperties(recordingParam)
      window.axios.put('recordings/' + recordingParam.id, recordingParam).then((response) => {
        if (response && response.status === 200) {
          vueComponent.$noty.success('La grabación se ha actualizado correctamente', {
            timeout: 3000,
            progressBar: true
          })
        } else {
          vueComponent.$set(recording, 'published', !recording.published)
        }
      })
    },
    filterProperties (obj) {
      Object.keys(obj).forEach(key => {
        if (key !== 'id' && key !== 'published' && key !== 'recordingUrl') {
          delete obj[key]
        }
      })
      return obj
    },
    dispatchShowReportEvent (recordingId) {
      window.EventBus.$emit('show-report', recordingId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Modals/SessionRecordingsSidebar.vue